export default {
  defaultUserCookie: {
    essential: 1,
    performance: 0,
  },
  defaultPersonalised: {
    recommendations: 0,
  },
};
